import formButton from '@/components/common/form-button/form-button.vue'
import { mapActions, mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import router from '@/router'
import VJsoneditor from '@/components/common/json-editor'

export default {
  components: {
    formButton,
    Multiselect,
    VJsoneditor
  },
  data() {
    return {
      newWorkflow: {
        config: {
          header: {},
          tabs: {}
        },
        name: null,
        service_id: null
      }
    }
  },
  computed: {
    ...mapGetters('service', ['serviceList'])
  },
  methods: {
    ...mapActions('service', ['getServices']),
    ...mapActions('workflow', ['createWorkflow']),
    pickServiceId: function (service) {
      this.newWorkflow.service_id = service.id
    },
    onCreateWorkflow: async function () {
      await this.$validator.validate()

      if (this.errors.items.length === 0) {
        try {
          await this.createWorkflow(this.newWorkflow)
          this.$notify({
            text: 'Workflow was created',
            type: 'success'
          })
          router.push({ name: 'workflows' })
        } catch (e) {
          this.$notify({
            text: 'Error while creating workflow',
            type: 'error'
          })
        }
      }
    }
  },
  created: function () {
    this.getServices()
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/workflows/workflow-add/workflow-add.js